/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsBalances} from '../api'

 export const useQueryGetSavingsBalances = createReactQueryHook('getSavingsBalances', getSavingsBalances)
